export const AppSettings = {
  AppEnabledOrganizationId: 'appEnabledOrganizationId',
  Theme: 'appTheme',
  AgencySelectionPopedUp: 'agencySelectionPoppedUp',
  IsStrataMasterEnabled: 'isStrataMasterEnabled',
  IsCreditCardActivatedOrg: 'isCreditCardActivatedOrg',
  IsAssetRegisterViewEnabled: 'isAssetRegisterViewEnabled',
};
